export default __webpack_public_path__ + "static/media/mh-header.aa695e82.png";